package com.ives.modules.compare;

import js.html.Element;
import js.Browser;

import com.ives.utils.Remoting.DicomImageData;
import com.ives.components.workspace.DicomWorkspace;
import com.ives.components.viewer.DicomViewer;
import com.ives.components.popup.Popup;
import com.ives.utils.Translator;
import com.ives.utils.Log;
import com.ives.utils.Remoting;

import com.ives.components.slider.Slider;
class Compare extends Module{
	static private inline var COMPARE_MODULE:String = "COMPARE_MODULE";
	static public inline var COMPARE_EVENT:String = "COMPARE_EVENT";

	public static var instance:Compare;

	private var divs:Array<Element>;

	public static var allowedIds:Array<String>;

	private var currentIndex:UInt;
	private var ids:Array<String>;
	private var downloading:Bool = false;
	private var compareWorkspaceId:Int;

	private static var stripTags = ~/(<([^>]+)>)/ig;

	public function new() {
		workspaceModule = false;

		instance = this;

		on(closeButton, "click", close);
		on(compare, "input", onFilter);
	}

	override public function init(dicomViewer:DicomViewer, ?dicomWorkspace:DicomWorkspace){
		super.init(dicomViewer, dicomWorkspace);

		dicomViewer.on("compare", onCompare);
	}

	private function onCompare(dicomImageData:DicomImageData){
		dispatchEvent(new ModuleEvent(COMPARE_EVENT, [dicomViewer.selectedWorkspaceId()], [dicomImageData.sourceName, dicomImageData.id], false ,true));
	}

	private function onFilter(){
		Log.debug('Filtering compare by ${compare.value}');

		for(row in divs){
			var content:String = stripTags.replace(row.innerHTML, "");

			if(content.toLowerCase().indexOf(compare.value.toLowerCase()) != -1)
				row.style.display = "table-row";
			else
				row.style.display = "none";
		}
	}

	private function close(){
		dispatch(Slider.CLOSE);
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == COMPARE_MODULE){
			Log.debug('Compare init...');

//			if(dicomViewer.workspaces.length > 1 && dicomViewer.selectedWorkspace() == null){
//				Browser.alert(Translator.getTransltaion("compare_select_min_one"));
//
//				return;
//			}

			new Slider(this).open("#viewer");

			compare.value = "";

			refresh();
		}

		if(event.type == COMPARE_EVENT){
			Log.debug('Compare event...');

			compareWorkspaceId = event.data[0];

			Remoting.getDicomImageData(event.strings[0], event.strings[1], onCompareDicomImageData);
		}
	}

	private function onCompareDicomImageData(dicomImageData:DicomImageData){
		compareWith(dicomImageData);

		close();
	}

	private function closeOther(dicomImageData:DicomImageData){
		Log.info("CLosing all" + dicomImageData);

		dispatchEvent(new ModuleEvent("CLOSE_OTHER", [dicomImageData.sourceName, dicomImageData.id], false ,true));

		close();
	}

	public function refresh(){
		if(allowedIds != null)
			onAllIds(allowedIds);
		else
			Remoting.getAllIds(dicomViewer.originalDicomImageData.sourceName, onAllIds);

		find("*[data-list]").innerHTML = '';

		var map:Map<String, DicomImageData> = new Map();

		for(workspace in this.dicomViewer.workspaces)
			map.set(workspace.dicomImageData.id + "/" + workspace.dicomImageData.sourceName, workspace.dicomImageData);

		for(id in map.keys())
			find("*[data-list]").appendChild(new OpenedSeries(map[id], (map[id].id + "/" + map[id].sourceName) != (dicomViewer.originalDicomImageData.id + "/" + dicomViewer.originalDicomImageData.sourceName), closeOther).viewElement);
	}

	private function onAllIds(data:Array<String>){
		Log.debug('Got ${data.length} ids');

		if(downloading)
			return;

		downloading = true;

		currentIndex = 0;
		ids = data;

		divs = [];

		clear();

		next();
	}

	private function next(){
		if(currentIndex >= ids.length){
			downloading = false;

			return;
		}

		Remoting.getDicomImageData(dicomViewer.originalDicomImageData.sourceName, ids[currentIndex], onDicomImageData);
	}

	private function onDicomImageData(dicomImageData:DicomImageData){
		Log.debug('Image data loaded!');

		var row:CompareRow = new CompareRow(dicomImageData);

		append(row);
		divs.push(row.viewElement);

		currentIndex++;

		next();
	}

	private function compareWith(dicomImageData:DicomImageData){
		if(dicomViewer.workspaces.length == 1){
			// we can't dispatch here, because pop up can be closed for other users
			dicomViewer.onEventFromModule(new ModuleEvent(DicomViewer.LAYOUT_CHANGE, [2, 1], [DicomViewer.WORKSPACE_NORMAL, DicomViewer.WORKSPACE_NORMAL]));

			dicomViewer.workspaces[1].initFromData(dicomImageData);
		}
		else
			dicomViewer.workspaces[compareWorkspaceId].initFromData(dicomImageData);
	}
}
